import React from 'react';

interface IconListSquareProps {
    iconClasses?: string;
}

const IconListSquare: React.FC<IconListSquareProps> = ({ iconClasses }) => {
    return (
        <svg
            width="18"
            height="17"
            viewBox="0 0 18 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-list-square ${iconClasses ?? ''}`}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5455 1.63636H2.45455C2.00267 1.63636 1.63636 2.00268 1.63636 2.45455V13.9091C1.63636 14.361 2.00268 14.7273 2.45455 14.7273H15.5455C15.9973 14.7273 16.3636 14.361 16.3636 13.9091V2.45455C16.3636 2.00267 15.9973 1.63636 15.5455 1.63636ZM2.45455 0C1.09894 0 0 1.09894 0 2.45455V13.9091C0 15.2647 1.09894 16.3636 2.45455 16.3636H15.5455C16.9011 16.3636 18 15.2647 18 13.9091V2.45455C18 1.09894 16.9011 0 15.5455 0H2.45455ZM4.09091 4.09091H5.72727V5.72727H4.09091V4.09091ZM8.18182 4.09091C7.72994 4.09091 7.36364 4.45723 7.36364 4.90909C7.36364 5.36096 7.72994 5.72727 8.18182 5.72727H13.0909C13.5428 5.72727 13.9091 5.36096 13.9091 4.90909C13.9091 4.45723 13.5428 4.09091 13.0909 4.09091H8.18182ZM5.72727 7.36364H4.09091V9H5.72727V7.36364ZM7.36364 8.18182C7.36364 7.72994 7.72994 7.36364 8.18182 7.36364H13.0909C13.5428 7.36364 13.9091 7.72994 13.9091 8.18182C13.9091 8.6337 13.5428 9 13.0909 9H8.18182C7.72994 9 7.36364 8.6337 7.36364 8.18182ZM5.72727 10.6364H4.09091V12.2727H5.72727V10.6364ZM7.36364 11.4545C7.36364 11.0027 7.72994 10.6364 8.18182 10.6364H13.0909C13.5428 10.6364 13.9091 11.0027 13.9091 11.4545C13.9091 11.9064 13.5428 12.2727 13.0909 12.2727H8.18182C7.72994 12.2727 7.36364 11.9064 7.36364 11.4545Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconListSquare;
